import { render } from "./MultipleSelect.vue?vue&type=template&id=b2ba644a&scoped=true&ts=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=ts"
export * from "./MultipleSelect.vue?vue&type=script&lang=ts"

import "./MultipleSelect.vue?vue&type=style&index=0&id=b2ba644a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ba644a"]])

export default __exports__